import React, { useContext, useState } from 'react'
import { useTranslation } from "react-i18next"

import { DomainContext } from '../../domain-repository/DomainRepository'

import { FooterWithClose } from '../../components/Footer'
import DriverInfoHeader from '../../components/PageHeader'
import withLang from '../../withLang'
import TrackingPage from '../../components/TrackingPage'
import { InfoTooltip } from '../../components/InfoTooltip'

function ReviewFinalReservationExtrasPage(props) {
  const { t } = useTranslation();

  const {
    reservation,
    selectedExtras,
    removeExtra,
    insuranceSelectedPack,
    changeInsurancePack,
    setInsuranceSelectedPack,
    saveRemovedExtra,
  } = useContext(DomainContext)

  return (
    <div style={{ height: 'calc(100% - 87px)' }}>
      <DriverInfoHeader
        title={t('reservationViewAll')}
        active={3}
        progress={'100%'}
        handleLogoClick={() => props.history.push('/start')}
      />
      <div className='page-layout'>
        <div className='container grow'>
          <div className="main-frame-resumo" style={{ height: '100%' }}>
            <h2 className="title pt-4">{t('reservationViewAll')}</h2>
            <div className="board-resumo col-12 mt-3">
              <Days days={reservation.raQuote.nrDays} />
              {selectedExtras.filter(e => !e.isPack && e.isUserRemovable).map((extra, i) =>
                <RemovableExtra key={extra.extraID + `${i}`} extra={extra} removeExtra={removeExtra} />
              )}
              {selectedExtras.filter(e => !e.isPack && !e.isUserRemovable).map((extra, i) =>
                <Extra key={extra.extraID + `${i}`} extra={extra} />
              )}
              {insuranceSelectedPack ?
                <PackExtra
                  extra={insuranceSelectedPack}
                  // GKIOSK-1889 - o cartao do Pack Basico (PE) nao e removivel aqui, tal como o PE
                  // vendido pela /exclusive-reservation nunca foi.
                  isRemovable={insuranceSelectedPack.isUserRemovable !== false}
                  handleRemove={() => {
                    changeInsurancePack(null, insuranceSelectedPack)
                    setInsuranceSelectedPack(null)
                    saveRemovedExtra({ ...insuranceSelectedPack, extraID: insuranceSelectedPack.extraId })
                  }}
                />
                : null}
            </div>
          </div>
        </div>
        <FooterWithClose
          handleCloseClick={() => props.history.goBack()}
        />
      </div>
    </div >
  )
}

export default withLang(TrackingPage(ReviewFinalReservationExtrasPage, 86))

function Days({ days }) {
  const { t } = useTranslation();

  return (
    <div className="board-background d-flex align-items-center mb-1 ra-review-extra">
      <div className="ico"><img src={require("../../assets/images/ico-check.png")} alt="" /></div>
      <div className="text pl-2 ">
        {t('dayCount', { count: days })}
      </div>
    </div>
  )
}

function Extra({ extra, }) {
  const { t } = useTranslation();
  return (
    <div className="board-background d-flex align-items-center mb-1 ra-review-extra">
      <div className="ico"><img src={require("../../assets/images/ico-check.png")} alt="" /></div>
      <div className="text pl-2 pr-1">
        {t(`${extra.extraID}ShortName`, t(`${extra.extraID}Name`))}
      </div>
      <InfoTooltip id={`e-${extra.extraID}`} text={t(`${extra.extraID}Description`)} />
    </div>
  )
}

function RemovableExtra({ extra, removeExtra }) {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="board-background d-flex align-items-center mb-1 ra-review-extra">
      <div className="ico"><img src={require("../../assets/images/ico-check.png")} alt="" /></div>
      <div className="text pl-2 pr-1">
        {t(`${extra.extraID}ShortName`, t(`${extra.extraID}Name`))}
      </div>
      <InfoTooltip id={`r_e-${extra.extraID}`} text={t(`${extra.extraID}Description`)} />
      <div className='rental-agreement-info__item__review--selected-extra-remove'>
        {
          isOpen ?
            <div className='rental-agreement-info__item__review-button-actions'>
              <div className='rental-agreement-info__item__review-button' onClick={() => removeExtra(extra, true)}>{t('unselect')}</div>
              <div className='rental-agreement-info__item__review-button' onClick={() => setIsOpen(false)}>{t('cancel')}</div>
            </div>
            :
            <div onClick={() => setIsOpen(true)} className="rental-agreement-info__item__review--selected-extra__icon">
              &times;
            </div>
        }
      </div>

    </div>
  )
}

function PackExtra({ extra, handleRemove, isRemovable = true }) {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="board-background d-flex align-items-center mb-1 ra-review-extra">
      <div className="ico"><img src={require("../../assets/images/ico-check.png")} alt="" /></div>
      <div className="text pl-2 pr-1">
        {extra.name}
      </div>
      <InfoTooltip id={`p_e-${extra.extraId}`} text={t(`${extra.extraId}Description`)} />
      <div className='rental-agreement-info__item__review--selected-extra-remove'>
        {
          !isRemovable ? null :
          isOpen ?
            <div className='rental-agreement-info__item__review-button-actions'>
              <div className='rental-agreement-info__item__review-button' onClick={() => handleRemove(extra, true)}>{t('unselect')}</div>
              <div className='rental-agreement-info__item__review-button' onClick={() => setIsOpen(false)}>{t('cancel')}</div>
            </div>
            :
            <div onClick={() => setIsOpen(true)} className="rental-agreement-info__item__review--selected-extra__icon">
              &times;
            </div>
        }
      </div>
    </div>
  )
}